import Header22 from './Header22'
export default Header22
